'use client';

import { Entering } from 'components';
import 'styles/legacy/application.scss';
import 'styles/legacy/font.scss';
import EmptyInvoice from './_components-legacy/EmptyInvoice';
import Invoice from './_components-legacy/Invoice';
import CurrentBalance from './_components/CurrentBalance';
import TableInvoices from './_components/TableInvoices';
import { useInvoicesContext } from './_context/InvoicesContext';

export default function Invoices() {
  const { currentInvoice } = useInvoicesContext();

  return (
    <div className="legacy pt-6">
      <div className="row !m-0 justify-between">
        <div className="dont_print w-[calc(50%_-_16px)]">
          <Entering offset={5} delay={0.6} duration={0.2} position="bottom">
            <CurrentBalance />
          </Entering>
          <Entering offset={5} delay={0.8} duration={0.2} position="bottom">
            <TableInvoices />
          </Entering>
        </div>
        <div className="invoices__paper__container mb-6 flex w-1/2 justify-end">
          {currentInvoice && (
            <Entering offset={5} delay={0.6} duration={0.2} position="bottom">
              <Invoice invoice={currentInvoice} />
            </Entering>
          )}
          {!currentInvoice && (
            <Entering offset={5} delay={0.8} duration={0.2} position="bottom">
              <EmptyInvoice />
            </Entering>
          )}
        </div>
      </div>
    </div>
  );
}
